import React from 'react';

const StickyTOC = ({ sections, activeSection, onSectionClick, readTimes = {} }) => {
  return (
    <div className="sticky top-6 w-64 flex-shrink-0">
      <div className="bg-white rounded-lg border border-gray-200 p-5">
        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-4">
          Articles
        </h3>
        <nav className="space-y-1">
          {sections.map((section) => {
            const isActive = activeSection === section.id;
            const readTime = readTimes[section.id];
            return (
              <button
                key={section.id}
                onClick={() => onSectionClick(section.id)}
                className={`block w-full text-left text-sm px-3 py-2 rounded-md transition-colors ${
                  isActive
                    ? 'bg-purple-50 text-purple-600 font-medium border-l-2 border-purple-600'
                    : 'text-gray-600 hover:text-purple-600 hover:bg-gray-50'
                }`}
                style={isActive ? { paddingLeft: '10px' } : {}}
              >
                <span className="block">{section.title}</span>
                {readTime && (
                  <span style={{ fontSize: '11px', color: '#999', fontWeight: 400 }}>
                    {readTime} min read
                  </span>
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default StickyTOC;
